import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import authService from '../services/authService';
import styles from '../components/Auth.module.css'; // Importa o novo CSS Module
import logo from '../assets/logo.jpg';

const LoginPage = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await authService.login(formData.email, formData.password);
      navigate('/dashboard'); // Redireciona para o dashboard
    } catch (err) {
      setError(err.message || 'Email ou senha inválidos. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.authPageBackground}> {/* Novo container de fundo */}
      <div className={`card ${styles.authCard}`}>
        <div className={styles.authHeader}>
          {/* Placeholder para o logo */}
          <div className={styles.authLogo}>
            <img src={logo} alt="Logo da Empresa" className={styles.authLogo} />
          </div>
          <h2>Bem-vindo de volta!</h2>
          <p>Acesse seu painel para gerenciar o seu negócio.</p>
        </div>
        <form onSubmit={handleSubmit} className={styles.authForm}>
          {error && <p className="error-message">{error}</p>} {/* Mensagem de erro global */}
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email" id="email" name="email"
              className="form-input"
              value={formData.email} onChange={handleChange}
              placeholder="seuemail@exemplo.com" required
              aria-label="Email"
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password" id="password" name="password"
              className="form-input"
              value={formData.password} onChange={handleChange}
              placeholder="********" required
              aria-label="Senha"
            />
          </div>
          
          <button type="submit" className={`btn btn-primary ${styles.authButton}`} disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
        <div className={styles.authFooter}>
          <p>Ainda não tem uma conta? <Link to="/register">Cadastre-se</Link></p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;